/**
 * Recently viewed products for the search box.
 *
 * SPEED: switched off. The search box used to fetch these products in the
 * background on every page load for returning visitors. Nothing is recorded
 * any more, any old list is cleared, and search always gets an empty list,
 * so it shows its normal product suggestions instead.
 * (The "Recently Viewed" row on product pages is separate and still works.)
 */
export class RecentlyViewed {
  /** @static @constant {string} The key the old list was stored under */
  static #STORAGE_KEY = 'viewedProducts';

  /**
   * No longer records anything.
   * @param {string} productId - Ignored.
   */
  static addProduct(productId) {}

  static clearProducts() {
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch (e) {}
  }

  /**
   * Always empty, and clears any list saved before this change.
   * @returns {string[]} An empty list.
   */
  static getProducts() {
    this.clearProducts();
    return [];
  }
}
